export const steps =
    [
        {
            key: 'address',
            title: 'Address'
        },
        {
            key: 'roofSize',
            title: 'Panel Amount'
        },
        {
            key: 'roofType',
            title: 'Roof Slope'
        },
        {
            key: 'products',
            title: 'Panel Type'
        },
        {
            key: 'summary',
            title: 'Summary'
        },
        {
            key: 'success',
            title: 'Success',
            skip: true,
        },
    ]
export const SLOPE_0 = 0;
export const SLOPE_15 = 15;
export const SLOPE_30 = 30;
export const slopes = [
    {
        title:'Flat',
        degrees:'0-15°',
        key: SLOPE_0
    },
    {
        title:'Low slope',
        degrees:'15-30°',
        key: SLOPE_15
    },
    {
        title:'Conventional slope',
        degrees:'30°>',
        key: SLOPE_30
    },
];

export const roof_materials = undefined == window.wgCalc.roofMaterials ? [ 'Takpanna','Plåt','Papp','Vet ej/osäker'] : window.wgCalc.roofMaterials ;
export const PANEL_AREA = window.wgCalc.panel.area || 2.94;
export const PANEL_MIN  = window.wgCalc.panel.min || 12;
export const PANEL_MAX  = window.wgCalc.panel.max || 70;

export const getRoofMeasurements = (polygon) => {
    const roofSize = Math.round(
        window.google.maps.geometry.spherical.computeArea(polygon.getPath())
    );
    return {
        roofSize: roofSize,
        panels: Math.floor((roofSize-4) / PANEL_AREA)
    };
};

export const matchGoogleFields = {
    locality: "short_name",
    postal_town: "short_name",
    administrative_area_level_1: "long_name",
    postal_code: "short_name",
    route: "short_name",
    street_number: "short_name",
};

export const getAddressStructure = (place) =>{
    const matchGoogleFieldKeys = Object.keys(matchGoogleFields);

    const response = {
        locality: "",
        postal_town: "",
        administrative_area_level_1: "",
        postal_code: "",
        route: "",
        street_number: "",
    };

    place.address_components.forEach((item) => {
        matchGoogleFieldKeys.forEach((googleKey) => {
            if (item.types.includes(googleKey)) {
                const valueType = (matchGoogleFields)[googleKey];
                response[googleKey] = item[valueType];
            }
        });
    });

    return {
        city:
            response.locality ||
            response.postal_town ||
            response.administrative_area_level_1 ||
            "",
        postcode: response.postal_code || "",
        street: `${response.route || ""} ${
            response.street_number || ""
        }`.trim(),
        coordinates: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
        },
    }
}

/**
 * Make all calculations dependent on panel count/type and accessories
 * @param state
 */
export const calcTotals = function (state){
    const panels = window.wgCalc.products || {};
    const accessories = window.wgCalc.accessories || [];
    if(!state.summary.panels.amount){
        Object.keys(state.invoice).forEach(e=>state.invoice[e] = 0);
        return;
    }

    if(undefined == window.wgCalc.priceCallback) {

        if (undefined == panels[state.summary.panels.type] || undefined == panels[state.summary.panels.type].priceMatrix[state.summary.panels.amount]) {
            return null;
        }
    }else{
        const calc = window.wgCalc.priceCallback(state.summary);
        state.invoice.panels  = calc.full;
        state.invoice.total = calc.total;
        state.invoice.greenDiscount = calc.discount;
        return  true;
    }



    const panel = panels[state.summary.panels.type];

    state.invoice.panels = panel.priceMatrix[state.summary.panels.amount].price;
    state.invoice.savings = 0;
    state.invoice.subtotal = Math.floor(
        state.invoice.panels
        +  accessories.map(i => state.summary.products.indexOf(i.key) >=0  ? i.price : 0)
            .reduce((a, b) => a + b, 0));
    state.invoice.greenDiscount = Math.floor(panel.priceMatrix[state.summary.panels.amount].greenDiscount
        + accessories.map(i => state.summary.products.indexOf(i.key) >=0  ?  (i.price * i.subsidyRatio) : 0)
            .reduce((a, b) => a + b, 0) );

    state.invoice.total = state.invoice.subtotal - state.invoice.greenDiscount
    return true;
}
